import * as PIXI from 'pixi.js'
import { PostIt, getShadowTexture } from './postit'
import { computeWorldSize } from './layout'
import { fanOut, isAnimating } from './animation'
import { updateWorld } from './viewport'

let postits = []
let rendering = false

function hideLoader() {
    const loader = document.getElementById('bt-loader')
    if (loader) loader.classList.add('bt-loader--hidden')
}

export function create(viewport, config, renderer) {
    if (!config || !config.items || !config.items.length) {
        hideLoader()
        return
    }

    const items = config.items
    const world = computeWorldSize(items)

    // Update viewport world dimensions and re-apply bounce/clamp
    updateWorld(world.width, world.height)

    // Collect all asset URLs to preload
    const urls = []
    if (config.assets && config.assets.stickyNotes) {
        config.assets.stickyNotes.forEach((url, i) => urls.push({ name: 'stickyNote_' + i, url }))
    }
    if (config.assets && config.assets.tape) {
        urls.push({ name: 'tape', url: config.assets.tape })
    }
    if (config.assets && config.assets.imageMask) {
        urls.push({ name: 'imageMask', url: config.assets.imageMask })
    }

    if (urls.length) {
        const loader = new PIXI.Loader()
        urls.forEach(({ name, url }) => loader.add(name, url))
        loader.load((_, resources) => {
            const assets = { stickyNotes: [] }
            if (config.assets && config.assets.stickyNotes) {
                config.assets.stickyNotes.forEach((_, i) => {
                    assets.stickyNotes.push(resources['stickyNote_' + i].texture)
                })
            }
            if (resources.tape) {
                assets.tape = resources.tape.texture
            }
            if (resources.imageMask) {
                assets.imageMask = resources.imageMask.texture
            }
            assets.shadowTexture = getShadowTexture(renderer)
            buildPostIts(viewport, items, world, assets)
        })
    } else {
        const assets = { stickyNotes: [], shadowTexture: getShadowTexture(renderer) }
        buildPostIts(viewport, items, world, assets)
    }
}

function buildPostIts(viewport, items, world, assets) {
    postits = items.map(item => {
        const adjustedItem = {
            ...item,
            x: item.x + world.offsetX,
            y: item.y + world.offsetY,
        }

        const postit = new PostIt(adjustedItem, assets)
        viewport.addChild(postit)
        return postit
    })

    // Center the viewport on the world
    const centerX = world.width / 2
    const centerY = world.height / 2

    viewport.moveCenter(centerX, centerY)

    // Hide loader, then start fan-out animation
    hideLoader()
    rendering = true
    fanOut(postits, centerX, centerY, () => {
        rendering = false
        viewport.dirty = true
    })
}

export function needsRender() {
    return rendering || isAnimating()
}
